<template>
    <div
        id="FeedBackResult"
        :style="{
            background: 'linear-gradient(0deg, var(--background-color-first), var(--background-color-second))',
            color: 'white',
        }"
    >
        <div v-if="!loading" class="fb-container">
            <div class="image-container">
                <img class="lg-none" :src="getAssetPath('static/img/confetti.png')" alt="" />
                <img class="sm-none" :src="getAssetPath('static/img/tebrikler.svg')" alt="" />
                <div class="title">
                    {{ $t("visitorLanguage.evaluation") }}<br />
                    {{ $t("visitorLanguage.thankYouEvaluation") }}
                </div>
            </div>

            <div class="button-wrapper">
                <div class="b-row" style="justify-content: center">

                    <DynamicSvg :name="'RefreshIcon'" />
                    <div class="text" @click="reconnect">{{ $t("visitorLanguage.reconnect") }}</div>
                </div>
                <div class="b-row" style="justify-content: center" @click="inputVisible = true">
                    <DynamicSvg :name="'LeaveMessageIcon'" />
                    <div class="text">{{ $t("visitorLanguage.sendTheConversationToEmail") }}</div>
                </div>
                <div style="padding: 0px 10px 0px 10px" class="input-wrapper" v-if="inputVisible">
                    <Input
                        :error="hasEmailError"
                        :errorMessage="this.$t('visitorLanguage.hasEmailError')"
                        @v-model="(e) => (email = e)"
                        :value="email"
                        :placeHolder="this.$t('visitorLanguage.emailAdress')"
                    />
                    <Button
                        borderRadius="99px"
                        paddingY="12px"
                        @btnClicked="() => startSendTranscript()"
                        bg-color="var(--button-color)"
                        >{{ $t("akinon.send") }}
                    </Button>
                </div>
            </div>
        </div>
        <div v-else class="loading-bar">
            <div class="sps-spinner"></div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
import Button from "../../common/Button.vue";
import DynamicSvg from "../../common/DynamicSvg.vue";
import Input from "../../common/Input.vue";
import { sendTranscript } from "../../api/chat";
import { log2 } from "../../utils/log2";
import { getAssetPath } from "./utils";
import * as _ from "lodash";
import { getPersistenceData } from "../../utils/persistenceStorage";
import { sendSocketMessage } from "../../utils/socketStream";
import { sessionId } from "../../utils/session";
import { getVisitorToken, VISITOR_TOKEN_SUPPORTED } from "../../utils/visitorToken";
import version from "../../utils/version";

const log = log2("Rate2");
export default {
    name: "FeedBackResult",
    components: { DynamicSvg, Input, Button },
    props: {},
    data: function () {
        return {
            inputVisible: false,
            email: "",
            hasEmailError: false,
            loading: true,
        };
    },
    methods: {
        getAssetPath,
        ...mapActions({
            resetConversation: "chat/resetConversation",
            toggleAfterActions: "app/toggleAfterActions",
            toggleRating: "app/toggleRating",
        }),
        ...mapMutations({
            changePageIndex: "app/CHANGE_PAGE",
        }),
        connect() {
            sendSocketMessage("visitor connect", {
                visitorId: this.visitorId,
                visitorToken: getVisitorToken(),
                tokenSupported: VISITOR_TOKEN_SUPPORTED,
                conversationId: this.conversationId,
                siteId: this.site._id,
                sessionId,
                version,
            });
        },
        reconnect() {
            this.changePageIndex(1);
            this.toggleRating(false);
            this.toggleAfterActions(false);
            this.resetConversation();
            this.connect();
        },
        startSendTranscript() {
            log("startSendTranscript başladı");
            let regex = new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,3}");
            if (!regex.test(this.email)) {
                this.hasEmailError = true;
                return;
            }

            this.loading = true;

            sendTranscript(this.conversationId, this.email)
                .then((x) => {
                    this.loading = false;
                    log("respons başarılı");
                    this.$message.success(this.$t("message.transcriptSent"));
                    this.sendTranscriptCount -= 1;
                    if (this.sendTranscriptCount === 0) {
                        this.transcriptIsSent = true;
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.loading = false;
                });
        },
        fillEmail() {
            let lastLoginData = JSON.parse(getPersistenceData("lastLoginData", null));
            let lastCustomLogins = JSON.parse(getPersistenceData("lastCustomLogins", null));
            let transMail;
            if (this.preDefinedUserData.initialized && !!this.preDefinedUserData.email) {
                transMail = this.preDefinedUserData.email;
            } else {
                if (!!lastLoginData && !!lastLoginData.email) {
                    transMail = lastLoginData.email;
                } else {
                    if (!!lastCustomLogins && !!lastCustomLogins[0].email) {
                        transMail = lastCustomLogins[0].email;
                    } else {
                        transMail = "";
                    }
                }
            }
            this.email = transMail;
        },
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            visitorId: (state) => state.chat.visitorId,
            conversationId: (state) => state.chat.lastConversationId,
            connected: (state) => state.chat.connected,
            settings: (state) => state.setting.settings,
            backgroundColorFirst: (state) =>
                _.get(
                    state,
                    "setting.settings.chatCustomizationSettings.versionV2Theme.colors.backgroundColorFirst",
                    "#fff"
                ),
            backgroundColorSecond: (state) =>
                _.get(
                    state,
                    "setting.settings.chatCustomizationSettings.versionV2Theme.colors.backgroundColorSecond",
                    "#fff"
                ),
            preDefinedUserData: (state) => state.chat.preDefinedUserData,
        }),
    },
    watch: {
        connected() {
            if (this.connected === true) {
                this.loading = true;
                return;
            }
            this.loading = false;
        },
        description: "updateButtonOpacity",
    },
    mounted() {
        if (!this.connected) {
            setInterval(() => {
                this.loading = false;
            }, 1000);
        }
        this.fillEmail();
    },
};
</script>
<style lang="scss">
#FeedBackResult {
    padding-bottom: 60px !important;
    .fb-container {
        width: 100%;
        height: 100%;

        .image-container {
            position: relative;
            margin-bottom: 20px;
            height: calc(100% - 95px);
            overflow: hidden;

            img {
                width: 100%;
                position: absolute;
                top: -30px;
            }

            .title {
                text-align: center;
                position: absolute;
                bottom: 50px;
                width: 100%;
                left: 0;
                color: #38386e;
                font-size: 28px;
                font-weight: 700;
                line-height: 33px;
            }
        }

        .button-wrapper {
            .b-row {
                display: flex;
                cursor: pointer;
                user-select: none;
                margin-left: 4px;

                &:not(:last-child) {
                    margin-bottom: 17px;
                }

                .text {
                    margin-left: 10px;
                    color: var(--form-input-text);
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 21px;
                }

                svg {
                    height: 17px !important;

                    path {
                    }
                }
            }

            .input-wrapper {
                display: flex;
                align-items: center;

                #button {
                    width: 100px;
                    margin-left: 5px;
                }
            }
        }
    }
    .loading-bar {
        margin: 0 auto;
        width: 150px;
        height: 150px;
        margin-top: 150px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/FeedBackResult.vue